import styled from "@emotion/styled";

export const AccountContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
  margin-bottom: 100px;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const AccountBody = styled.div`
  /* width: 100%; */
  border: 1px solid var(--alias-color-line-normal);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
`;

export const AccountItem = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;
  height: 64px;
  padding: 0 0 0 20px;
`;
